const Testimonials = () => {
  const testimonials = [
    {
      quote: "My daughter has been Corinne's client since she was 10 years old. In those almost 7 years, I've watched my daughter develop tools to manage anxiety, confidence to tackle challenging situations, and countless skills to help her navigate the wild world of life as a teenager. Corinne's use of art in her sessions allowed my daughter to open up when she was new to therapy. It also inspired her to draw, paint and scrapbook on her own, which has become an outlet and a way for her to reduce stress. But beyond the art, we value Corinne's warmth, her extraordinary ability to connect, and her commitment to supporting our daughter. We're so grateful we found Corinne; anyone would be lucky to have her in their corner.",
      author: "D Owens"
    },
    {
      quote: "Working with Miss Corinne has been one of the greatest gifts to our family. From the very first session, she formed an immediate connection with my son and made him feel comfortable, safe, and understood. He genuinely looks forward to seeing her and often asks, “Is it a Miss Corinne day?”—a true testament to the relationship she has built with him.\n\nEvery session is thoughtfully planned with activities and materials that match my son’s interests, keeping him engaged while helping him develop important emotional and social skills. Corinne is also incredibly flexible and accommodating, always willing to work around our busy schedule to ensure my son receives the support he needs.\n\nWhat truly sets Corinne apart is the way she supports our entire family. She regularly takes the time to connect with me about my son’s sessions, offering guidance, language, and practical strategies that help me continue the work at home and navigate difficult conversations with confidence and compassion. She has also collaborated with my son’s school adjustment counselor, creating a strong partnership between home, school, and therapy so everyone is working toward the same goals.\n\nThe support Corinne has provided extends far beyond therapy sessions. She has helped our family navigate some of the most challenging moments we have experienced with our six-year-old, and we are incredibly grateful for her expertise, kindness, and unwavering dedication. We feel so fortunate to have her as part of our support system and cannot recommend her highly enough.",
      author: "Ashley Condon, M.S.Ed, BCBA"
    }
  ];

  return (
    <section
      className="relative overflow-hidden"
      style={{
        backgroundImage: "url('/images/flowers.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute inset-0 bg-purple-600/55" style={{backgroundColor: 'rgba(147, 112, 219, 0.55)'}} />

      <div className="relative mx-auto max-w-6xl px-5 py-8 md:py-10">
        <h2 className="text-center text-3xl md:text-4xl font-nunito text-white mb-8">
          Client Testimonials
        </h2>
        <div className="grid gap-8 md:gap-10">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="max-w-4xl mx-auto">
              <div className="text-white/85 text-center italic text-sm md:text-base space-y-3">
                {testimonial.quote.split("\n\n").map((paragraph, pIndex, arr) => (
                  <p key={pIndex}>
                    {pIndex === 0 && '"'}
                    {paragraph}
                    {pIndex === arr.length - 1 && '"'}
                  </p>
                ))}
              </div>
              <div className="mt-3 text-white/70 text-center text-xs">
                ~ {testimonial.author}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Curve into CTA */}
      <svg
        className="block w-full"
        viewBox="0 0 1440 160"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
      >
        <path
          d="M0,80 C240,140 720,140 960,100 C1200,60 1320,40 1440,60 L1440,160 L0,160 Z"
          fill="#ffffff"
        />
      </svg>
    </section>
  );
};

export default Testimonials;
